declare var $: any;

export default function headerDrawerToggle() {
(function() {
    $('.js-header-drawer-trigger').on('click', function(){
        $(this).toggleClass('is-active');
        $('#js-header').toggleClass('is-active');
        $('.js-header-drawer-body').toggleClass('is-active');
        $('.js-header-search-body').toggleClass('is-active');
    });
}());
}
